// UserActionOverlay.tsx

import { OverlayPanel } from 'primereact/overlaypanel';
import { Button } from 'primereact/button';
import { Tooltip } from 'primereact/tooltip';

interface Action {
  label: string;
  icon: string;
  className: string;
  command?: () => void;
  disabled?: boolean;
  tooltip?: string;
}

interface UserActionOverlayProps {
  actions: Action[];
  overlayRef: React.RefObject<OverlayPanel>;
}

const UserActionOverlay: React.FC<UserActionOverlayProps> = ({
  actions,
  overlayRef,
}) => {
  return (
    <OverlayPanel ref={overlayRef}>
      <div className="flex flex-column gap-2 p-1">
        {actions.map((action, index) => (
          <span
            key={index}
            data-pr-tooltip={action.disabled ? action.tooltip : undefined}
            className={`user-action-item-${index}`}
            style={{ display: 'inline-block', width: '100%' }}
          >
            {action.disabled && action.tooltip && (
              <Tooltip target={`.user-action-item-${index}`} position="left" />
            )}
            <Button
              label={action.label}
              icon={action.icon}
              className={`p-button-text ${action.className}`}
              style={{
                textAlign: 'left',
                justifyContent: 'flex-start',
                width: '100%',
              }}
              disabled={action.disabled}
              onClick={() => {
                if (action.disabled || !action.command) return;
                action.command();
                overlayRef.current?.hide();
              }}
            />
          </span>
        ))}
      </div>
    </OverlayPanel>
  );
};

export default UserActionOverlay;
